export function getGoalAssistLabel(goal) {
  if (!goal) return null;

  const assistId = goal.assistPlayerId?.trim();
  const assistName = goal.assistPlayerName?.trim();

  if (!assistId && !assistName) {
    return null;
  }

  if (!assistName || assistName.toLowerCase() === 'unknown') {
    return null;
  }

  return assistName;
}

export function formatGoalAssist(goal) {
  const assistName = getGoalAssistLabel(goal);
  return assistName ? `assist: ${assistName}` : null;
}
